import { render, staticRenderFns } from "./TableActionsWrapper.vue?vue&type=template&id=96a0a134"
import script from "./TableActionsWrapper.vue?vue&type=script&lang=js"
export * from "./TableActionsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports